export default {
  formValidation: {
    emptyField: 'Pole nemôže byť prázdne',
    requiredField: 'Pole je povinné',
    passwordToShort: 'Heslo musí mať 8 znakov',
    emailNotValid: 'Pole musí obsahovať platnú e-mailovú adresu',
    emailReserved: 'E-mailová adresa je už obsadená',
    rateEmpty: 'Všetky polia musia byť vyplnené',
    serverUnknownError: 'Chyba komunikácie so serverom',
    invalidCharacters: 'Pole obsahuje neplatné znaky',
    phoneNotValid: 'Telefónne číslo je nesprávne',
    checkBoxBelow: 'Prosím, zaškrtnite políčko nižšie, aby ste mohli poslať správu',
  },
  password: {
    show: 'zobraziť',
    hide: 'skryt',
  },
  howItWorks: {
    showButton: 'Zobraziť viac',
    hideButton: 'Zobraziť menej',
  },
}
